import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { CommonUtilitiesService } from '../common-utilities.service';

@Component({
  selector: 'app-payment-view-urlerror',
  templateUrl: './payment-view-urlerror.component.html',
  styleUrls: ['./payment-view-urlerror.component.scss']
})
export class PaymentViewUrlerrorComponent implements OnInit {

  errorMsg = "";

  constructor(public LANG: CommonUtilitiesService, private route: ActivatedRoute) { }

  ngOnInit() {

    let _self = this;
    this.route.params.subscribe(params => this.setErrorParams(params));
  }

  setErrorParams(params) {
    this.errorMsg = params.errorMsg;
  }


}
